// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__11T11","col":"styles_col__1Bnbm"};